export enum SseEvents {
  NEW_MESSAGE = "new-message",
  ARCHIVE_UPDATED = "archive-updated",
  BACKUP_CREATED = "backup-created",
  STUDY_CREATED = "study-created",
  STUDY_ARCHIVED = "study-archived",
  STUDY_RESTORED = "study-restored",
  STUDY_ASSIGNED = "study-assigned",
  STUDY_UPDATED = "study-updated",
  STUDY_REPORTED = "study-reported",
  STUDY_SHARED = "study-shared",
  STUDY_UNSHARED = "study-unshared",
  STUDY_DELETED = "study-deleted",
  STUDY_REJECTED = "study-rejected",
  STUDY_SHARING_FORCED = "study-sharing-forced",
  STUDY_ARCHIVING_REQUESTED = "study-archiving-requested",
  STUDY_IMPORTED = "study-imported",
  STUDY_DELIVERED = "study-delivered",
  REPORT_CREATED = "report-created",
  REPORT_REJECTED = "report-rejected",
  REQUEST_CREATED = "request-created",
  REQUEST_ACCEPTED = "request-accepted",
  REQUEST_UPDATED = "request-updated",
  REQUEST_DELETED = "request-deleted",
  REQUEST_REJECTED = "request-rejected",
  WORKLIST_CREATED = "worklist-created",
  WORKLIST_UPDATED = "worklist-updated",
  CUSTOMER_CREATED = "customer-created",
  CUSTOMER_DELETED = "customer-deleted",
  CUSTOMER_UPDATED = "customer-updated",
  ACCOUNT_CREATED = "account-created",
  ACCOUNT_DELETED = "account-deleted",
  ACCOUNT_UPDATED = "account-updated",
  PATIENT_CREATED = "patient-created",
  PATIENT_UPDATED = "patient-updated",
  PATIENT_MERGED = "patient-merged",
  PATIENT_RESURRECTED = "patient-resurrected",
  PATIENT_DECEASED = "patient-deceased",
  PATIENT_DELETED = "patient-deleted",
  PATIENT_WEIGHING = "patient-weighing-created",
  MESSAGE_CREATED = "message-created",
  MESSAGE_UPDATED = "message-updated",
  MESSAGE_DELETED = "message-deleted",
  APPOINTMENT_CREATED = "appointment-created",
  APPOINTMENT_UPDATED = "appointment-updated",
  APPOINTEMNT_CANCELED = "appointment-canceled",
  APPOINTMENT_DELETED = "appointment-deleted",
  APPOINTMENT_RESCHEDULED = "appointment-rescheduled",
  APPOINTMENT_NOSHOWED = "appointment-no-showed",
  SERVICE_CREATED = "service-created",
  SERVICE_UPDATED = "service-updated",
  SERVICE_DELETED = "service-deleted",
  TICKET_CREATED = "ticket-created",
  TICKET_UPDATED = "ticket-updated",
  TICKET_DELETED = "ticket-deleted",
  TICKET_CHECKED_IN = "ticket-checked-in",
  TICKET_STARTED = "ticket-started",
  TICKET_COMPLETED = "ticket-completed",
  TICKET_CHECKED_OUT = "ticket-checked-out",
  HEALTH_RECORD_TEMPLATE_CREATED = "health-record-template-created",
  HEALTH_RECORD_TEMPLATE_CLONED = "health-record-template-cloned",
  HEALTH_RECORD_TEMPLATE_UPDATED = "health-record-template-updated",
  HEALTH_RECORD_TEMPLATE_DELETED = "health-record-template-deleted",
  HEALTH_RECORD_DELETED = "health-record-deleted",
  HEALTH_RECORD_CREATED = "health-record-created",
  HEALTH_RECORD_UPDATED = "health-record-updated",
  HEALTH_RECORD_COMPLETED = "health-record-completed",
  HEALTH_RECORD_REOPENED = "health-record-reopened",
  TASK_CREATED = "task-created",
  TASK_UPDATED = "task-updated",
  TASK_DELETED = "task-deleted",
  TASK_COMPLETED = "task-completed",
  RATE_TABLE_CREATED = "rate-table-created",
  RATE_TABLE_UPDATED = "rate-table-updated",
  RATE_TABLE_DELETED = "rate-table-deleted",
  RATE_TABLE_ITEM_CREATED = "rate-table-item-created",
  RATE_TABLE_ITEM_UPDATED = "rate-table-item-updated",
  RATE_TABLE_ITEM_DELETED = "rate-table-item-deleted",
  HOSPITALIZATION_CREATED = "hospitalization-created",
  HOSPITALIZATION_UPDATED = "hospitalization-updated",
  HOSPITALIZATION_DELETED = "hospitalization-deleted",
  MEMBER_CREATED = "member-created",
  MEMBER_DELETED = "member-deleted",
  MEMBER_UPDATED = "member-updated",
  MEMBER_ENABLED = "member-enabled",
  MEMBER_DISABLED = "member-disabled",
  WORK_ORDER_CREATED = "work-order-created",
  WORK_ORDER_UPDATED = "work-order-updated",
  WORK_ORDER_RECONCILED = "work-order-reconciled",
  WORK_ORDER_DELETED = "work-order-deleted",
  WORK_ORDER_ITEM_UPDATED = "work-order-item-updated",
  DRUG_CREATED = "drug-created",
  DRUG_UPDATED = "drug-updated",
  DRUG_DELETED = "drug-deleted",
  PACKAGING_CREATED = "packaging-created",
  PACKAGING_UPDATED = "packaging-updated",
  PACKAGING_DELETED = "packaging-deleted",
  PRODUCT_CREATED = "product-created",
  PRODUCT_UPDATED = "product-updated",
  CONFIGURATION_UPDATED = "configuration-updated",
  CALENDAR_CONFIGURATION_UPDATED = "calendar-configuration-updated",
  CONFIGURATION_BILLING_UPDATED = "configuration-billing-updated",
  CONFIGURATION_HEALTHCARE_UPDATED = "configuration-healthcare-updated",
  PRODUCT_DELETED = "product-deleted",
  DOCUMENT_CREATED = "document-created",
  DOCUMENT_UPDATED = "document-updated",
  DOCUMENT_DELETED = "document-deleted",
  MESSAGE_TEMPLATE_CREATED = "template-created",
  MESSAGE_TEMPLATE_UPDATED = "template-updated",
  MESSAGE_TEMPLATE_DELETED = "template-deleted",
  MEDICAL_SERVICE_CREATED = "medical-service-created",
  MEDICAL_SERVICE_UPDATED = "medical-service-updated",
  MEDICAL_SERVICE_DELETED = "medical-service-deleted",
  PHYSICIAN_CREATED = "physician-created",
  PHYSICIAN_UPDATED = "physician-updated",
  PHYSICIAN_DELETED = "physician-deleted",
  PHYSICIAN_DROP_PAGE_ENABLED = "physician-drop-page-enabled",
  PHYSICIAN_DROP_PAGE_DISABLED = "physician-drop-page-disabled",
  CART_CREATED = "cart-created",
  CART_ITEM_ADDED = "cart-item-added",
  CART_ITEM_UPDATED = "cart-item-updated",
  CART_ITEM_DELETED = "cart-item-deleted",
  CART_UPDATED = "cart-updated",
  INVOICE_CREATED = "invoice-created",
  INVOICE_UPDATED = "invoice-updated",
  INVOICE_EMITTED = "invoice-emitted",
  INVOICE_DELETED = "invoice-deleted",
  INVOICE_LOCKED = "invoice-locked",
  INVOICE_UNLOCKED = "invoice-unlocked",
  INVOICE_PAYMENT_ADDED = "invoice-payment-added",
  INVOICE_PAYMENT_UPDATED = "invoice-payment-updated",
  INVOICE_PAYMENT_DELETED = "invoice-payment-deleted",
  INVOICE_ITEM_DELETED = "invoice-item-deleted",
  FISCAL_PROFILE_CREATED = "fiscal-profile-created",
  FISCAL_PROFILE_UPDATED = "fiscal-profile-updated",
  FISCAL_PROFILE_DELETED = "fiscal-profile-deleted",
  QUOTE_CREATED = "quote-created",
  QUOTE_UPDATED = "quote-updated",
  QUOTE_DELETED = "quote-deleted",
  QUOTE_ACCEPTED = "quote-accepted",
  QUOTE_REJECTED = "quote-rejected",
  QUOTE_UNACCEPTED = "quote-unaccepted",
  QUOTE_UNREJECTED = "quote-unrejected",
  QUOTE_TEMPLATE_CREATED = "quote-template-created",
  QUOTE_TEMPLATE_UPDATED = "quote-template-updated",
  QUOTE_TEMPLATE_DELETED = "quote-template-deleted",
  QUOTE_TEMPLATE_ITEM_ADDED = "quote-template-item-added",
  QUOTE_TEMPLATE_ITEM_UPDATED = "quote-template-item-updated",
  QUOTE_TEMPLATE_ITEM_DELETED = "quote-template-item-deleted",
  BOOK_CREATED = "book-created",
  BOOK_ITEM_ADDED = "book-item-added",
  BOOK_ITEM_UPDATED = "book-item-updated",
  BOOK_ITEM_DELETED = "book-item-deleted",
  SALE_CREATED = "sale-created",
  BOOK_ITEM_EXECUTORS_SET = "book-item-executors-set",
  BOOK_ITEM_EXECUTION_DATE_SET = "book-item-execution-date-set",
  USER_UPDATED = "user-updated",
  TENANT_CREATED = "tenant-created",
  TENANT_DELETED = "tenant-deleted",
  TENANT_UPDATED = "tenant-updated",
  DOMAIN_CREATED = "domain-created",
  DOMAIN_UPDATED = "domain-updated",
  DOMAIN_DELETED = "domain-deleted",
  PRESCRIPTION_CREATED = "prescription-created",
  PRESCRIPTION_UPDATED = "prescription-updated",
  PRESCRIPTION_CANCELED = "prescription-canceled",
  PRESCRIPTION_DELETED = "prescription-deleted",
  PRESCRIPTION_EMITTED = "prescription-emitted",
  PRESCRIPTION_DRUG_ADDED = "prescription-drug-added",
  PRESCRIPTION_DRUG_UPDATED = "prescription-drug-updated",
  PRESCRIPTION_DRUG_DELETED = "prescription-drug-deleted",
  ATTACHMENT_CREATED = "attachment-created",
  ATTACHMENT_UPDATED = "attachment-updated",
  ATTACHMENT_UPLOADED = "attachment-uploaded",
  ATTACHMENT_SIGNED = "attachment-signed",
  ATTACHMENT_DELETED = "attachment-deleted",
  WORK_ORDER_EXAM_PARAMETER_UPDATED = "work-order-exam-parameter-updated",
  TAG_CREATED = "tag-created",
  TAG_UPDATED = "tag-updated",
  TAG_DELETED = "tag-deleted",
  SENDING_CREATED = "sending-created",
  SENDING_UPDATED = "sending-updated",
  SENDING_SENT = "sending-sent",
  SENDING_DISCARDED = "sending-discarded",
  SENDING_REJECTED = "sending-rejected",
  SENDING_OUTCOME_DETAIL_UPLOADED = "sending-outcome-detail-uploaded",
  SENDING_RECEIPT_UPLOADED = "sending-receipt-uploaded",
  APPOINTMENT_TEMPLATE_CREATED = "appointment-template-created",
  APPOINTMENT_TEMPLATE_UPDATED = "appointment-template-updated",
  APPOINTMENT_TEMPLATE_DELETED = "appointment-template-deleted",
  PAYMENT_METHOD_CREATED = "payment-method-created",
  PAYMENT_METHOD_UPDATED = "payment-method-updated",
  PAYMENT_METHOD_DELETED = "payment-method-deleted",
  PAYMENT_METHOD_DISABLED = "payment-method-disabled",
  EXPORT_CREATED = "export-created",
  EXPORT_COMPLETED = "export-completed",
  EXPORT_REJECTED = "export-rejected",
  IMPORT_CREATED = "import-created",
  IMPORT_COMPLETED = "import-completed",
  IMPORT_REJECTED = "import-rejected",
  BANK_ACCOUNTS_CREATED = "bank-accounts-created",
  BANK_ACCOUNTS_UPDATED = "bank-accounts-updated",
  BANK_ACCOUNTS_DELETED = "bank-accounts-deleted",
  REMINDER_CREATED = "reminder-created",
  REMINDER_DELETED = "reminder-deleted",
  REMINDER_UPDATED = "reminder-updated",
  REMINDER_SENT = "reminder-sent",
  PASSIVE_INVOICE_CREATED = "passive-invoice-created",
  PASSIVE_INVOICE_PAYMENT_ADDED = "passive-invoice-payment-added",
  PASSIVE_INVOICE_PAYMENT_UPDATED = "passive-invoice-payment-updated",
  PASSIVE_INVOICE_PAYMENT_DELETED = "passive-invoice-payment-deleted",
  RECOVERY_CREATED = "recovery-created",
  RECOVERY_DELETED = "recovery-deleted",
  RECOVERY_UPDATED = "recovery-updated",
  RECOVERY_COMPLETED = "recovery-completed",
  GOOD_CREATED = "good-created",
  GOOD_UPDATED = "good-updated",
  GOOD_LOADED = "good-loaded",
  GOOD_UNLOADED = "good-unloaded",
  GOOD_DELETED = "good-deleted",
  VACCINE_CREATED = "vaccine-created",
  VACCINE_DELETED = "vaccine-deleted",
  VACCINE_UPDATED = "vaccine-updated",
  LETTERHEAD_CREATED = "letterhead-created",
  LETTERHEAD_UPDATED = "letterhead-updated",
  LETTERHEAD_DELETED = "letterhead-deleted",
  ROOM_CREATED = "room-created",
  ROOM_UPDATED = "room-updated",
  ROOM_DELETED = "room-deleted",
  ROLE_CREATED = "role-created",
  ROLE_DELETED = "role-deleted",
  ROLE_UPDATED = "role-updated",
  SHIFT_ADDED = "shift-added",
  SHIFT_UPDATED = "shift-updated",
  SHIFT_DELETED = "shift-deleted",
  FISCAL_PROFILE_SECTIONAL_ADDED = "fiscal-profile-sectional-added",
  FISCAL_PROFILE_SECTIONAL_UPDATED = "fiscal-profile-sectional-updated",
  FISCAL_PROFILE_SECTIONAL_DELETED = "fiscal-profile-sectional-deleted",
  STORAGE_CREATED = "storage-created",
  STORAGE_DELETED = "storage-deleted",
  STORAGE_UPDATED = "storage-updated",
  SUPPLIER_CREATED = "supplier-created",
  SUPPLIER_DELETED = "supplier-deleted",
  SUPPLIER_UPDATED = "supplier-updated",
  MOVEMENT_CREATED = "movement-created",
  MOVEMENT_DELETED = "movement-deleted",
  MOVEMENT_UPDATED = "movement-updated",
  BUSINESS_UNIT_CREATED = "business-unit-created",
  BUSINESS_UNIT_DELETED = "business-unit-deleted",
  BUSINESS_UNIT_UPDATED = "business-unit-updated",
  SURVEY_CREATED = "survey-created",
  SURVEY_COMPLETED = "survey-completed",
  SURVEY_SENT = "survey-sent",
  ALARM_CREATED = "alarm-created",
  INSTALLATION_CREATED = "installation-created",
  INSTALLATION_DELETED = "installation-deleted",
  INSTALLATION_UPDATED = "installation-updated",
  INSTALLATION_DISABLED = "installation-disabled",
  INSTALLATION_ENABLED = "installation-enabled",
  CONNECTION_CREATED = "connection-created",
  CONNECTION_DELETED = "connection-deleted",
  CONNECTION_UPDATED = "connection-updated",
  CONNECTION_SHARED = "connection-shared",
  CONNECTION_UNSHARED = "connection-unshared",
  CAMPAIGN_CREATED = "campaign-created",
  CAMPAIGN_UPDATED = "campaign-updated",
  CAMPAIGN_DELETED = "campaign-deleted",
  CAMPAIGN_ENABLED = "campaign-enabled",
  CAMPAIGN_DISABLED = "campaign-disabled",
  CAMPAIGN_SENT = "campaign-sent",
  SEGMENTATION_CREATED = "segmentation-created",
  SEGMENTATION_UPDATED = "segmentation-updated",
  SEGMENTATION_DELETED = "segmentation-deleted",
  STORE_SERVICE_CREATED = "store-service-created",
  STORE_SERVICE_UPDATED = "store-service-updated",
  STORE_SERVICE_DELETED = "store-service-deleted",
  ORDER_CREATED = "order-created",
  ORDER_UPDATED = "order-updated",
  ORDER_DELETED = "order-deleted",
  DRAFT_DOCUMENT_CREATED = "draft-document-created",
  DRAFT_DOCUMENT_UPDATED = "draft-document-updated",
  DRAFT_DOCUMENT_DELETED = "draft-document-deleted"
}
